import React from 'react';
// Shared SVG Icons for the application

// Icon colors for different feature types
export const iconColors: Record<string, string> = {
    chart: '#3b82f6',
    folder: '#3b82f6',
    pill: '#3b82f6',
    message: '#3b82f6',
    tag: '#3b82f6',
    hospital: '#3b82f6',
    zap: '#3b82f6',
    trending: '#3b82f6',
    bacteria: '#3b82f6',
    dna: '#3b82f6',
    heart: '#3b82f6',
    check: '#3b82f6',
    clipboard: '#3b82f6',
    testTube: '#3b82f6',
    sparkles: '#3b82f6',
    brain: '#3b82f6',
};

export const Icons: Record<string, (color?: string) => React.ReactElement> = {
    chart: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"></line>
            <line x1="12" y1="20" x2="12" y2="4"></line>
            <line x1="6" y1="20" x2="6" y2="14"></line>
        </svg>
    ),
    folder: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
        </svg>
    ),
    pill: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.5 20.5l10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7z"></path>
            <path d="M8.5 8.5l7 7"></path>
        </svg>
    ),
    message: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
    ),
    tag: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
            <line x1="7" y1="7" x2="7.01" y2="7"></line>
        </svg>
    ),
    hospital: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 21h18" />
            <path d="M5 21V7l8-4 8 4v14" />
            <path d="M13 21v-8" />
            <path d="M9 10a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v3h-6v-3z" />
        </svg>
    ),
    zap: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
        </svg>
    ),
    trending: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
            <polyline points="17 6 23 6 23 12"></polyline>
        </svg>
    ),
    bacteria: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
            <line x1="9" y1="9" x2="9.01" y2="9"></line>
            <line x1="15" y1="9" x2="15.01" y2="9"></line>
        </svg>
    ),
    dna: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
    ),
    heart: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
    ),
    check: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
    ),
    clipboard: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
            <path d="M9 12h6"></path>
            <path d="M9 16h6"></path>
        </svg>
    ),
    testTube: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.5 2v13.5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2V2"></path>
            <path d="M8.5 2h7"></path>
            <path d="M9 12h6"></path>
        </svg>
    ),
    sparkles: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3l1.912 5.813a2 2 0 0 0 1.275 1.275L21 12l-5.813 1.912a2 2 0 0 0-1.275 1.275L12 21l-1.912-5.813a2 2 0 0 0-1.275-1.275L3 12l5.813-1.912a2 2 0 0 0 1.275-1.275L12 3z"></path>
        </svg>
    ),
    brain: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9.5 2h5a5.5 5.5 0 0 1 5.5 5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2a3.5 3.5 0 0 0-3.5-3.5h-5a3.5 3.5 0 0 0-3.5 3.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2A5.5 5.5 0 0 1 9.5 2z"></path>
            <path d="M12 14a5 5 0 0 0-5-5v0a5 5 0 0 0-5 5v2.5a3.5 3.5 0 0 0 3.5 3.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-1a1.5 1.5 0 0 1-1.5-1.5V14a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v2.5a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h1a3.5 3.5 0 0 0 3.5-3.5V14z"></path>
            <path d="M17 14a5 5 0 0 0-5-5v0a5 5 0 0 0-5 5v2.5a3.5 3.5 0 0 0 3.5 3.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-1a1.5 1.5 0 0 1-1.5-1.5V14a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v2.5a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h1a3.5 3.5 0 0 0 3.5-3.5V14z"></path>
            <path d="M12 14v4"></path>
            <path d="M9 14h6"></path>
        </svg>
    ),
    circle: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
        </svg>
    ),
    moon: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
    ),
    screen: (color = '#3b82f6') => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
            <line x1="8" y1="21" x2="16" y2="21"></line>
            <line x1="12" y1="17" x2="12" y2="21"></line>
        </svg>
    ),
};

export type IconKey = keyof typeof Icons;

export function getIcon(key: string): React.ReactElement | null {
    const iconFn = Icons[key];
    if (!iconFn) return null;
    const color = iconColors[key] || '#3b82f6';
    return iconFn(color);
}
